import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: 'app-mall-profile',
  templateUrl: './mall-profile.component.html',
  styleUrls: ['./mall-profile.component.scss']
})
export class MallProfileComponent implements OnInit {
  
  mall:any;

  constructor(
    private authservice:AuthService,
    private router:Router
  ) { }

  ngOnInit() {
    let mall = JSON.parse(localStorage.getItem('USER'))
    this.mall = mall.info
    console.log(this.mall)

  }

}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/mall/mall-profile/mall-profile.component.ts